import reduce from 'lodash/reduce';

const prefixCall = 'Request/';

const url = 'https://server-lead.makeyoudigit.com/';

/*
	example
	{
	    id: 'example',
	    url: `${url}`,
	    method: 'put',
	    queryParams: ['km'],
	    bodyParams: ['id', 'name'],
	    showLog: true,
	    tokenRequired: true
	}
*/

const actionsData = [
	{
		id: 'insertLead',
		url: `${url}leads/{idLanding}`,
		method: 'post',
		bodyParams: [ 'nome', 'telefono' ],
		showLog: true,
		tokenRequired: false
	}
];

export default {
	actionsData,
	mockapi: false,

	...reduce(
		actionsData,
		(accumulator, element) => {
			const key = element.id.toUpperCase();
			accumulator[ `LOAD_${key}` ] = `${prefixCall}LOAD_${key}`;
			accumulator[ `LOAD_${key}_SUCCESS` ] = `${prefixCall}LOAD_${key}_SUCCESS`;
			accumulator[ `LOAD_${key}_ERROR` ] = `${prefixCall}LOAD_${key}_ERROR`;
			accumulator[ `LOAD_${key}_CLEAR` ] = `${prefixCall}LOAD_${key}_CLEAR`;
			return accumulator;
		},
		{}
	)
};



// WEBPACK FOOTER //
// ./src/libraries/reducers/http-request/constants.js